// File: Blog.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './Blog.css'; // Make sure this CSS file exists
import Navbar from '../Navbar/Navbar'; // Your component
import Footer from '../Footer/Footer'; // Your component

const API_BASE_URL = 'https://api.hitkarihospital.com:5005'; // Your backend URL

// A default image in case a blog post doesn't have one
const DEFAULT_IMAGE = 'https://via.placeholder.com/600x400.png?text=Image+Not+Found';

const Blog = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchBlogData = async () => {
            setLoading(true);
            setError('');
            try {
                // Step 1: Fetch blogs from the single, correct endpoint
                const response = await axios.get(`${API_BASE_URL}/api/blogs`);

                // Step 2: Map the data from the backend to the format our component needs
                const formattedBlogs = response.data.map(blog => {
                    const imageUrl = blog.picture
                        ? `${API_BASE_URL}/blog/${blog.picture}`
                        : DEFAULT_IMAGE;

                    const displayDate = new Date(blog.date).toLocaleDateString('en-US', {
                        year: 'numeric', month: 'long', day: 'numeric'
                    });

                    return {
                        _id: blog._id,
                        title: blog.subject,
                        description: blog.description,
                        author: blog.authorName,
                        category: blog.category || 'Hospital Blog',
                        imageUrl: imageUrl,
                        displayDate: displayDate
                    };
                }).sort((a, b) => new Date(b.date) - new Date(a.date));

                setBlogs(formattedBlogs);

            } catch (err) {
                setError('Failed to fetch blog posts. Please try again later.');
                console.error("Fetch Error:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogData();
    }, []);



    return (
        <>
            <div className="main-wrapper">
                <header className="header"><Navbar /></header>

                <div className="breadcrumb-bar">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-md-12 col-12">
                                <nav aria-label="breadcrumb" className="page-breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Blog</li>
                                    </ol>
                                </nav>
                                <h2 className="breadcrumb-title">From Our Clinic</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <main id="blogs-page-content" className="blogs-page-content">
                    <div id="blogs-container" className="blogs-container">
                        {loading && <div className="blog-loader">Loading...</div>}
                        {error && <p className="blog-error-message">{error}</p>}

                        {!loading && !error && (
                            <>
                                {blogs.length > 0 ? (
                                    <section id="blogs-grid-section" className="blogs-grid-section">
                                        <h3 className="blogs-section-title">Our Blogs</h3>
                                        <div id="blogs-grid" className="blogs-grid">
                                            {blogs.map(blog => (
                                                <div key={blog._id} id={`blog-card-${blog._id}`} className="blogs-card">
                                                    <div className="blogs-card-image-wrapper">
                                                        <Link to={`/blog/${blog._id}`}>
                                                            <img
                                                                src={blog.imageUrl}
                                                                alt={blog.title}
                                                                className="blogs-card-image" />
                                                        </Link>
                                                    </div>
                                                    <div className="blogs-card-content">
                                                        <div className="blogs-card-tags">
                                                            <span className="blogs-card-tag">{blog.category}</span>
                                                        </div>
                                                        <h4 className="blogs-card-title">
                                                            <Link to={`/blog/${blog._id}`}>{blog.title}</Link>
                                                        </h4>
                                                        <div className="blogs-card-meta">
                                                            <span>By {blog.author}</span>
                                                            <span>{blog.displayDate}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </section>
                                ) : (
                                    <p id="blogs-no-articles-message">No articles have been posted yet.</p>
                                )}
                            </>
                        )}
                    </div>
                </main>
            </div>
            <Footer />
        </>
    );
};

export default Blog;